<template>

    <transition name="fade">
        <div v-if="message" class="alert" :class="classes" role="alert">
            <span>{{ message }}</span>
        </div>
    </transition>

</template>

<style scoped lang="scss">

    .alert {

        @include font-medium(12px);
        background: #fff;
        border: none;
        border-radius: 3px;
        color: $color-info;
        line-height: 1.6em;
        margin-bottom: 20px;
        padding: 15px 20px;
        text-align: center;
        word-wrap: break-word;

        &.alert-info {
            background: rgba($color-primary, 0.1);
            color: $color-primary;
        }
        &.alert-success {
            background: rgba($color-success, 0.1);
            color: $color-success;
        }
        &.alert-warning {
            background: rgba($color-warning, 0.1);
            color: $color-warning;
        }
        &.alert-danger {
            background: rgba($color-danger, 0.1);
            color: $color-danger;
        }

    }

</style>

<script>

export default {

    props: {
        type: {
            type: String,
            default: 'danger',
        },
        message: {
            type: String,
        },
    },

    computed: {

        classes() {
            return {
                'alert-info': this.type === 'info',
                'alert-success': this.type === 'success',
                'alert-warning': this.type === 'warning',
                'alert-danger': this.type === 'danger',
            };
        },

    },

}

</script>
